/**
 * Hook per leggere i pulsanti azione contribuiti dai plugin abilitati
 * per un certo entityType.
 *
 * I plugin dichiarano `actionContributors` nel manifest (vedi
 * @crm/contracts/ActionContributor). Questo hook filtra su:
 *   - plugin autorizzati dal backend (user.plugins)
 *   - plugin non disabilitati via toggle localStorage
 *   - contributor con entityType corrispondente
 *
 * Usato tipicamente da componenti detail del core (es. MessageSidebar)
 * per renderizzare pulsanti aggiuntivi senza conoscere il plugin.
 */

import { useMemo } from 'react';
import type { ActionContributor } from '@crm/contracts';
import { useEnabledPlugins } from './useEnabledPlugins';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useActionContributors(entityType: string): ActionContributor<any>[] {
  const enabledPlugins = useEnabledPlugins();
  return useMemo(
    () =>
      enabledPlugins.flatMap((p) =>
        (p.actionContributors ?? []).filter((a) => a.entityType === entityType),
      ),
    [enabledPlugins, entityType],
  );
}
